import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: 'd6817473-6c44-45a5-a494-cbc7ca1917a2',
  ENV: 'laCelleSaintCloud',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr',
  matomoSiteId: 8,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
